import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import {
  setImageBase64,
  setImageBase64List,
  setMarkerStyleQuestion,
} from './marker-style.actions';
import { insertElementArrayAtIndex } from '@trim-web-apps/core';
import { FormSpecific } from '3map-models';
import * as uuid from 'uuid';
import * as formActions from './form.actions';
import * as specificActions from './form-specific.actions';
import * as AdminActions from '../../+state/admin.actions';
// import { AdminActions } from '../../+state';
import { MarkerStyleEntity } from './marker-style.entity';
import { FieldType } from '3map-models/dist/lib/model';

export const ADMIN_MARKER_STYLE_FEATURE_KEY = 'admin-marker-style';

export const DEFAULT_MARKER_BASE64 =
  'data:image/png;base64,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';

export type State = EntityState<MarkerStyleEntity>;

export const adapter = createEntityAdapter<MarkerStyleEntity>({
  selectId: (entity: MarkerStyleEntity) => entity.specificId,
});
const initialState = adapter.getInitialState();

const markerStyleReducer = createReducer(
  initialState,
  on(
    AdminActions.close,
    AdminActions.initProjectError,
    (): State => ({ ...initialState }),
  ),
  on(AdminActions.initProjectSuccess, (state, { project, icons }): State => {
    const entities = project.formList
      .map((f) => f.specificList.map((s) => createEntity(s, icons)))
      .reduce((acc, item) => [...acc, ...item], []);
    return adapter.setAll(entities, state);
  }),
  on(formActions.addDuplicatedForm, (state, { form, icons }) => {
    const entities = form.specificList.map((specific) =>
      createEntity(specific, icons),
    );
    return adapter.addMany(entities, state);
  }),
  on(formActions.removeForm, (state, { form }) => {
    const entitiesIds = form.specificList.map((specific) => specific.id);
    return adapter.removeMany(entitiesIds, state);
  }),
  on(specificActions.createSpecific, (state, { formId, specific }) => {
    const entity = {
      ...createEntity(specific, []),
      image: uuid.v4(),
      imgBase64List: [DEFAULT_MARKER_BASE64],
    };
    return adapter.addOne(entity, state);
  }),
  on(specificActions.duplicateSpecific, (state, { specific, icons }) => {
    return adapter.addOne(createEntity(specific, icons), state);
  }),
  on(specificActions.upsertQuestions, (state, { specificId, questions }) => {
    return updateStateOnQuestionsChange(state, specificId, questions);
  }),
  on(
    specificActions.upsertQuestionGroup,
    (state, { specificId, questionsGroupList }) => {
      const questions = questionsGroupList
        .map((group) => group.questions)
        .reduce((acc, item) => [...acc, ...item]);
      return updateStateOnQuestionsChange(state, specificId, questions);
    },
  ),
  on(specificActions.removeSpecific, (state, { specificId }) => {
    return adapter.removeOne(specificId, state);
  }),
  // TODO check this
  on(setMarkerStyleQuestion, (state, { specificId, question }) => {
    const markerStyleEntity = state.entities[specificId];
    if (!markerStyleEntity) return state;

    if (question === null) {
      /* no field type => default (single) icon */
      // TODO first icon should always be available
      const imgBase64List = markerStyleEntity.imgBase64List[0]
        ? [markerStyleEntity.imgBase64List[0]]
        : [DEFAULT_MARKER_BASE64];
      const entity: MarkerStyleEntity = {
        specificId,
        image: markerStyleEntity.image,
        imageNumber: 1,
        imgBase64List,
      };
      return adapter.setOne(entity, state);
    } else {
      // field type selected
      const imageNumber = (question.options || []).length + 1;
      const entity: MarkerStyleEntity = {
        specificId,
        image: markerStyleEntity.image,
        imageNumber,
        imgBase64List: [],
        iconFieldType: question.id,
      };
      for (let i = 0; i < imageNumber; i++) {
        entity.imgBase64List[i] =
          markerStyleEntity.imgBase64List[i] || DEFAULT_MARKER_BASE64;
      }

      return adapter.setOne(entity, state);
    }
  }),
  on(setImageBase64, (state, { specificId, base64, index }) => {
    const markerStyleEntity = state.entities[specificId];
    if (!markerStyleEntity) return state;

    const imgBase64List = insertElementArrayAtIndex(
      markerStyleEntity.imgBase64List,
      base64,
      index,
    );

    return adapter.updateOne(
      {
        id: specificId,
        changes: { imgBase64List, image: uuid.v4() },
      },
      state,
    );
  }),
  on(setImageBase64List, (state, { specificId, imgBase64List }) => {
    return adapter.updateOne(
      {
        id: specificId,
        changes: { imgBase64List },
      },
      state,
    );
  }),
);

export function reducer(state: State | undefined, action: Action) {
  return markerStyleReducer(state, action);
}

function createEntity(
  specific: FormSpecific,
  icons: { specificId: string; imgBase64List: string[] }[],
): MarkerStyleEntity {
  const imgBase64List = icons.find((i) => i.specificId === specific.id);
  return {
    ...specific.markerStyle,
    specificId: specific.id,
    imgBase64List: imgBase64List ? imgBase64List.imgBase64List : [],
  };
}

function updateStateOnQuestionsChange(
  state: State,
  specificId: string,
  questions: FieldType[],
): State {
  const msEntity = state.entities[specificId];
  if (!msEntity) return state;
  const question = questions.find((q) => q.id === msEntity?.iconFieldType);
  if (!question) {
    const entity = {
      specificId: msEntity.specificId,
      image: msEntity.image,
      imageNumber: 1,
      imgBase64List: [msEntity.imgBase64List[0]],
    };
    return adapter.setOne(entity, state);
  } else {
    const imageNumber = (question.options?.length || 0) + 1;
    const imgBase64List = [];
    for (let i = 0; i < imageNumber; i++) {
      imgBase64List[i] = msEntity.imgBase64List[i] || DEFAULT_MARKER_BASE64;
    }
    const entity = {
      ...msEntity,
      imageNumber,
      imgBase64List,
      iconFieldType: question.id,
    };
    return adapter.setOne(entity, state);
  }
}
